import React from "react";

const Autofill = (props) => {
  const selectOption = (Opt) => {
    if (props.Type === "TITLE") {
      props.SelectTitle(Opt);
    } else if (props.Type === "SKILLS") {
      props.SelectSkill(Opt);
    } else if (props.Type === "LOCATION") {
      props.SelectLocation(Opt);
    }
  };

  // returns the className based on the length of
  // {props.Results} array, to fit the hight
  // of the wrapper element witht the count of the options.
  const handleWrapperClassname = () => {
    if (props.Results) {
      if (props.Results.length === 1) {
        return "autofill-wrapper";
      } else if (props.Results.length > 1 && props.Results.length === 2) {
        return "autofill-wrapper autofill-md";
      } else if (props.Results.length > 2) {
        return "autofill-wrapper autofill-bg";
      }
    }
  };
  return (
    <>
      {props.SelectedSkills.length < 5 ? (
        <div className={handleWrapperClassname()}>
          {props.Results && props.Results.length > 0 ? (
            <>
              {props.Results.map((Item, i) => (
                <h1 key={i} onClick={() => selectOption(Item)}>
                  {Item}
                </h1>
              ))}
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default Autofill;
